// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewCategory-viewCategoryContainer-ZFkNR {
  display: grid;
  grid-template-columns: 1fr 404px;
  gap: 24px;
  grid-gap: 24px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.ViewCategory-viewCategoryImgContainer-DsG58 {
  width: 100%;
  position: relative;
  height: 322px;
  border-radius: 18px 18px 0 0;
}

.ViewCategory-viewCategoryImgContainer-DsG58 img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  border-radius: inherit;
  background-color: var(--common-hover-bg);
}

.ViewCategory-viewCategoryInfoContainer-eYK3G {
  padding: 24px;
  background: var(--background-primary);
  border-radius: 0 0 18px 18px;
}

.ViewCategory-viewCategoryInfoTitle-u6n5t {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: var(--primary-foreground);
  margin-bottom: 12px;
  text-align: start;
}

.ViewCategory-viewCategoryInfoDesc-VKLt0 {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--primary-foreground);
  margin-bottom: 0;
  text-align: start;
}

.ViewCategory-viewCategorySearchContainer-KOw50 {
  padding: 24px;
  background: var(--background-primary);
  border-radius: 18px;
}

.ViewCategory-viewCategoryLoaderContainer-gJi1N {
  padding: 220px 0;
}

@media (min-width: 1200px) {
  .ViewCategory-viewCategoryRsBox-pFWZG {
    position: sticky;
    top: 100px;
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .ViewCategory-viewCategoryRsBox-pFWZG {
    position: sticky;
    top: 88px;
  }
}

@media (max-width: 991px) {
  .ViewCategory-viewCategoryContainer-ZFkNR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }

  .ViewCategory-viewCategoryLsBox-S9d4w {
    -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
            order: 2;
    width: 100%;
  }

  .ViewCategory-viewCategoryInfoContainer-eYK3G,
  .ViewCategory-viewCategorySearchContainer-KOw50 {
    padding: 18px;
  }

  .ViewCategory-viewCategoryRsBox-pFWZG {
    -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
            order: 1;
    width: 100%;
  }
}

@media (max-width: 767px) {
  .ViewCategory-viewCategoryInfoTitle-u6n5t {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 6px;
  }

  .ViewCategory-viewCategoryInfoDesc-VKLt0 {
    font-size: 14px;
    line-height: 24px;
  }
}

@media (max-width: 440px) {
  .ViewCategory-viewCategoryImgContainer-DsG58 {
    height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewCategory/ViewCategory/ViewCategory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,0BAAuB;KAAvB,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;;EAEA;IACE,4BAAQ;QAAR,iBAAQ;YAAR,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,4BAAQ;QAAR,iBAAQ;YAAR,QAAQ;IACR,WAAW;EACb;AACF;;AAGA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".viewCategoryContainer {\n  display: grid;\n  grid-template-columns: 1fr 404px;\n  gap: 24px;\n  grid-gap: 24px;\n  align-items: flex-start;\n}\n\n.viewCategoryImgContainer {\n  width: 100%;\n  position: relative;\n  height: 322px;\n  border-radius: 18px 18px 0 0;\n}\n\n.viewCategoryImgContainer img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  border-radius: inherit;\n  background-color: var(--common-hover-bg);\n}\n\n.viewCategoryInfoContainer {\n  padding: 24px;\n  background: var(--background-primary);\n  border-radius: 0 0 18px 18px;\n}\n\n.viewCategoryInfoTitle {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 30px;\n  color: var(--primary-foreground);\n  margin-bottom: 12px;\n  text-align: start;\n}\n\n.viewCategoryInfoDesc {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--primary-foreground);\n  margin-bottom: 0;\n  text-align: start;\n}\n\n.viewCategorySearchContainer {\n  padding: 24px;\n  background: var(--background-primary);\n  border-radius: 18px;\n}\n\n.viewCategoryLoaderContainer {\n  padding: 220px 0;\n}\n\n@media (min-width: 1200px) {\n  .viewCategoryRsBox {\n    position: sticky;\n    top: 100px;\n  }\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n  .viewCategoryRsBox {\n    position: sticky;\n    top: 88px;\n  }\n}\n\n@media (max-width: 991px) {\n  .viewCategoryContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .viewCategoryLsBox {\n    order: 2;\n    width: 100%;\n  }\n\n  .viewCategoryInfoContainer,\n  .viewCategorySearchContainer {\n    padding: 18px;\n  }\n\n  .viewCategoryRsBox {\n    order: 1;\n    width: 100%;\n  }\n}\n\n\n@media (max-width: 767px) {\n  .viewCategoryInfoTitle {\n    font-size: 18px;\n    line-height: 28px;\n    margin-bottom: 6px;\n  }\n\n  .viewCategoryInfoDesc {\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n@media (max-width: 440px) {\n  .viewCategoryImgContainer {\n    height: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCategoryContainer": `ViewCategory-viewCategoryContainer-ZFkNR`,
	"viewCategoryImgContainer": `ViewCategory-viewCategoryImgContainer-DsG58`,
	"viewCategoryInfoContainer": `ViewCategory-viewCategoryInfoContainer-eYK3G`,
	"viewCategoryInfoTitle": `ViewCategory-viewCategoryInfoTitle-u6n5t`,
	"viewCategoryInfoDesc": `ViewCategory-viewCategoryInfoDesc-VKLt0`,
	"viewCategorySearchContainer": `ViewCategory-viewCategorySearchContainer-KOw50`,
	"viewCategoryLoaderContainer": `ViewCategory-viewCategoryLoaderContainer-gJi1N`,
	"viewCategoryRsBox": `ViewCategory-viewCategoryRsBox-pFWZG`,
	"viewCategoryLsBox": `ViewCategory-viewCategoryLsBox-S9d4w`
};
module.exports = ___CSS_LOADER_EXPORT___;
